import { makeKey, update } from "../../../../utils/reducerOperations";
export function ForgotPasswordStarted(state, payload) {
  return makeKey(
    "forgotPasswordApi",
    update(state.forgotPasswordApi, { isProcessing: true })
  );
}
